import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
//import App from './healthcare_marketing_website_single_file_react_tailwind';
//import App from './Qwen_jsx_20250822_bbp7csdsl';
//import App from './Qwen_jsx_20250822_dqr4y9pe1';
//import LoanCalculator from './LoanCalculator';
//import App from './react_js_2_ภาษา_healthcare_rose_gold_landing_page';
//import App from './Qwen_jsx_20250825_z83kgy1ph';
//import { ThemeProvider } from "@material-tailwind/react";

import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
   
      <App />
    
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
